import * as React from "react";

import { FormContext, FormContextValue } from "../contexts/FormContext";
import { NoFormContextError } from "../utils/errors";

/**
 * Hook providing access to the current context within a form.
 * @throws {NoFormContextError} When no form is in context.
 * @returns The current context within a form.
 */
export function useFormContext<T = unknown>(): FormContextValue<T> {
  const formContext = React.useContext(FormContext);
  if (!formContext) {
    throw new NoFormContextError();
  }
  return formContext;
}
